import styled from 'styled-components'

const Caption3 = styled.div`
  color: #000000;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 1px;
  text-transform: uppercase;
`

export default Caption3



// WEBPACK FOOTER //
// ./src/components/typography/captions/Caption3.js